var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5303 16.5303C19.2641 16.7966 18.8474 16.8208 18.5538 16.6029L18.4697 16.5303L12 10.061L5.53033 16.5303C5.26406 16.7966 4.8474 16.8208 4.55379 16.6029L4.46967 16.5303C4.2034 16.2641 4.1792 15.8474 4.39705 15.5538L4.46967 15.4697L11.4697 8.46967C11.7359 8.2034 12.1526 8.1792 12.4462 8.39705L12.5303 8.46967L19.5303 15.4697C19.8232 15.7626 19.8232 16.2374 19.5303 16.5303Z",
    fill: "#E4F6EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.6a9a751696cae5f331d3487a530fd56e.svg";
export { ForwardRef as ReactComponent };